const pricingData = {
  baseNightlyRate: 327,
  cleaningFee: 100,
  vatPercent: 0.13,
  minimumDepositPercent: 0.5,
  cashDiscountPercent: 0.06,
  minimumNights: 5,
  maximumNights: 21,
  maxGuests: 16,
  extraGuestThreshold: 12,
  extraGuestFee: 20,
  // Costa Rica seasonal rates (dry season Dec-Apr is peak, green season May-Nov is lower)
  seasonalRates: [
    { name: "Peak Dry Season", startMonth: 12, endMonth: 12, rate: 450 },
    { name: "Dry Season", startMonth: 1, endMonth: 4, rate: 400 },
    { name: "Holiday Weeks", startMonth: 12, endMonth: 12, rate: 500 },
    { name: "Green Season", startMonth: 5, endMonth: 8, rate: 275 },
    { name: "Shoulder Season", startMonth: 9, endMonth: 11, rate: 327 },
  ],
  dateOverrides: [],
};

export function getNightlyRate(date, pricing = pricingData) {
  let dateStr;
  if (date instanceof Date) {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const d = String(date.getDate()).padStart(2, "0");
    dateStr = `${y}-${m}-${d}`;
  } else {
    dateStr = date;
  }

  // Check date-specific overrides first
  if (pricing.dateOverrides) {
    const override = pricing.dateOverrides.find((o) => dateStr >= o.start && dateStr < o.end);
    if (override) return override.rate;
  }

  const month = date instanceof Date ? date.getMonth() + 1 : parseInt(dateStr.split("-")[1], 10);
  const seasonal = pricing.seasonalRates.find((s) => month >= s.startMonth && month <= s.endMonth);
  return seasonal ? seasonal.rate : pricing.baseNightlyRate;
}

export function calculateTotal(checkIn, checkOut, pricing = pricingData, numGuests = 0) {
  const oneDay = 24 * 60 * 60 * 1000;
  const nights = Math.round((checkOut - checkIn) / oneDay);

  if (nights < pricing.minimumNights) {
    return null;
  }

  if (nights > (pricing.maximumNights || 21)) {
    return null;
  }

  let accommodationTotal = 0;
  const current = new Date(checkIn);
  for (let i = 0; i < nights; i++) {
    accommodationTotal += getNightlyRate(current, pricing);
    current.setDate(current.getDate() + 1);
  }

  // Extra guest surcharge: per person per night over the threshold
  const threshold = pricing.extraGuestThreshold || 12;
  const feePerPerson = pricing.extraGuestFee || 0;
  const guests = parseInt(numGuests, 10) || 0;
  const extraGuestCount = Math.max(0, guests - threshold);
  const extraGuestNightlyRate = extraGuestCount * feePerPerson;
  const extraGuestTotal = extraGuestNightlyRate * nights;

  const subtotalBeforeVat = accommodationTotal + extraGuestTotal;
  const vat = Math.round(subtotalBeforeVat * (pricing.vatPercent || 0.13));
  const total = subtotalBeforeVat + pricing.cleaningFee + vat;
  const minimumDeposit = Math.ceil(total * pricing.minimumDepositPercent);
  const balanceDue = total - minimumDeposit;
  const cashDiscount = pricing.cashDiscountPercent || 0.06;
  const balanceCash = Math.round(balanceDue * (1 - cashDiscount));

  return {
    nights,
    accommodationTotal: subtotalBeforeVat,
    cleaningFee: pricing.cleaningFee,
    vat,
    vatPercent: pricing.vatPercent || 0.13,
    total,
    minimumDeposit,
    depositPercent: pricing.minimumDepositPercent || 0.5,
    balanceDue,
    balanceCash,
    cashDiscountPercent: cashDiscount,
  };
}

export default pricingData;
